import { MChatRiscoEnum } from 'graphql/types.generated'
import { useAtendimentoContext } from 'hooks/atendimento-context/useAtendimentoContext'
import { calculateAge } from 'util/date/calculateAge'

import { MChatRfResultadoView } from '../../components/MChatRfResultadoView'
import { MCHAT_RESULTADOS } from '../../model-mChatRf'
import { MChatRiscoPrevioRelevanteInfoModel, MChatViewModel } from '../model-mchat'
import { MChatEscala } from './MChatEscala'

interface MChatResultadoViewProps {
  value: MChatViewModel
  isInsideModal?: boolean
  showEscala?: boolean
  alertaMChatAnterior?: MChatRiscoPrevioRelevanteInfoModel
  isRegistradoAgora: boolean
}

export function MChatResultadoView(props: MChatResultadoViewProps) {
  const {
    value: { resultado, risco, footerInfo },
    isInsideModal = false,
    showEscala,
    alertaMChatAnterior,
    isRegistradoAgora,
  } = props

  const {
    atendimentoProfissional: { iniciadoEm: dataAtendimento } = {},
    cidadao: { dataNascimento },
  } = useAtendimentoContext()

  const ageInMonthsResultadoAnterior =
    footerInfo?.dataResultado && dataNascimento
      ? calculateAge(dataNascimento, footerInfo.dataResultado).ageInMonths
      : undefined
  const ageInMonths =
    dataNascimento && dataAtendimento ? calculateAge(dataNascimento, dataAtendimento.getTime()).ageInMonths : undefined

  const deveExibirAlertaRiscoBaixoApos24Meses =
    ageInMonths !== undefined && ageInMonthsResultadoAnterior !== undefined
      ? ageInMonths >= 24 && !isRegistradoAgora && risco === MChatRiscoEnum.BAIXO && ageInMonthsResultadoAnterior < 24
      : false

  const { status, title, encaminhamento } = MCHAT_RESULTADOS[risco]

  return (
    <MChatRfResultadoView
      status={status}
      title={title}
      description={encaminhamento(ageInMonths)}
      label={'ponto'.pluralizeAndConcatValue(resultado)}
      content={showEscala && <MChatEscala isInsideModal={isInsideModal} pontuacao={resultado} risco={risco} />}
      footerInfo={footerInfo}
      alertaMChatAnterior={alertaMChatAnterior}
      deveExibirAlertaRiscoBaixoApos24Meses={deveExibirAlertaRiscoBaixoApos24Meses}
    />
  )
}
